<template>
  <table class="policy_table">
    <tr>
      <td class="policy_table_title" colspan="8">业务信息</td>
    </tr>
    <tr>
      <td class="policy_table_label" :style="policy_table_info.policy_number == '' ? 'color:red' : '' ">保单号</td>
      <td class="policy_table_field">{{ policy_table_info.policy_number }}</td>
      <td class="policy_table_label" :style="policy_table_info.effective_date == null ? 'color:red' : '' ">生效日期</td>
      <td class="policy_table_field">{{ policy_table_info.effective_date }}</td>
      <td class="policy_table_label" :style="policy_table_info.expiration_date == null ? 'color:red' : '' ">到期日期</td>
      <td class="policy_table_field">{{ policy_table_info.expiration_date }}</td>
      <td class="policy_table_label" :style="policy_table_info.issue_month == null ? 'color:red' : '' ">出单月份</td>
      <td class="policy_table_field">{{ policy_table_info.issue_month }}</td>
    </tr>
    <tr>
      <td class="policy_table_label" :style="policy_table_info.ship_name == '' ? 'color:red' : '' ">船名</td>
      <td class="policy_table_field">{{ policy_table_info.ship_name }}</td>
      <td class="policy_table_label" :style="policy_table_info.applicant == '' ? 'color:red' : '' ">投保人</td>
      <td class="policy_table_field">{{ policy_table_info.applicant }}</td>
      <td class="policy_table_label" :style="policy_table_info.insured == '' ? 'color:red' : '' ">被保险人</td>
      <td class="policy_table_field">{{ policy_table_info.insured }}</td>
      <td class="policy_table_label">团体险</td>
      <td class="policy_table_field">{{ policy_table_info.is_group_insurance | value2word }}</td>
    </tr>
    <tr>
      <td class="policy_table_label">经办保险公司</td>
      <td class="policy_table_field">{{ policy_table_info.insurance_company }}</td>
      <td class="policy_table_label">所属分公司</td>
      <td class="policy_table_field">{{ policy_table_info.insurance_company_branch_office }}</td>
      <td class="policy_table_label">险种</td>
      <td class="policy_table_field">{{ policy_table_info.insurance_type }}</td>
      <td class="policy_table_label" :style="policy_table_info.business_type == '' ? 'color:red' : '' ">业务类型</td>
      <td class="policy_table_field">{{ policy_table_info.business_type }}</td>
    </tr>
    <tr>
      <td class="policy_table_label">竞价业务</td>
      <td class="policy_table_field">{{ policy_table_info.is_bid | value2word }}</td>
    </tr>
    <tr>
      <td class="policy_table_title" colspan="8">业务关系</td>
    </tr>
    <tr>
      <td class="policy_table_label" 
          :style="policy_table_info.business_area == null || policy_table_info.business_area == '' ? 'color:red' : '' ">
        业务区域
      </td>
      <td class="policy_table_field">{{ policy_table_info.business_area }}</td>
      <td class="policy_table_label">推荐人</td>
      <td class="policy_table_field">{{ policy_table_info.referrer }}</td>
      <td class="policy_table_label">业务来源</td>
      <td class="policy_table_field">{{ policy_table_info.business_source }}</td>
      <td class="policy_table_label">托管代理人</td>
      <td class="policy_table_field">{{ policy_table_info.escrow_agent }}</td>
    </tr>
    <tr>
      <td class="policy_table_title" colspan="8">财务信息</td>
    </tr>
    <tr>
      <td class="policy_table_label" :style="policy_table_info.premium == 0 ? 'color:red' : '' ">保费</td>
      <td class="policy_table_field">{{ policy_table_info.premium }}</td>
      <td class="policy_table_label">手续费税率调整</td>
      <td class="policy_table_field">{{ policy_table_info.vat_rate }}</td>
      <td class="policy_table_label">手续费比例</td>
      <td class="policy_table_field">{{ policy_table_info.commission_rate }}</td>
      <td class="policy_table_label">手续费收入</td>
      <td class="policy_table_field">{{ policy_table_info.commission }}</td>
    </tr>
    <tr>
      <td class="policy_table_label">佣金支出比例</td>
      <td class="policy_table_field">{{ policy_table_info.commission_2agent_rate }}</td>
      <td class="policy_table_label">佣金支出</td>
      <td class="policy_table_field">{{ policy_table_info.commission_2agent }}</td>
      <td class="policy_table_label">扣减税金</td>
      <td class="policy_table_field">{{ policy_table_info.vat }}</td>
      <td class="policy_table_label">乙禾手续费</td>
      <td class="policy_table_field">{{ policy_table_info.commission_2yihe }}</td>
    </tr>
    <tr>
      <td class="policy_table_label">开票金额比例</td>
      <td class="policy_table_field">{{ policy_table_info.invoice_rate }}</td>
      <td class="policy_table_label">开票金额</td>
      <td class="policy_table_field">{{ policy_table_info.invoice }}</td>
      <td class="policy_table_label">不开票金额比例</td>
      <td class="policy_table_field">{{ policy_table_info.un_invoice_rate }}</td>
      <td class="policy_table_label">不开票金额</td>
      <td class="policy_table_field">{{ policy_table_info.un_invoice }}</td>
    </tr>
    <tr>
      <td class="policy_table_label">手续费收入日期</td>
      <td class="policy_table_field">{{ policy_table_info.collected_date }}</td>
      <td class="policy_table_label">佣金支出日期</td>
      <td class="policy_table_field">{{ policy_table_info.commission_2agent_date }}</td>
      <td class="policy_table_label"></td>
      <td class="policy_table_field"></td>
      <td class="policy_table_label"></td>
      <td class="policy_table_field"></td>
    </tr>
    <tr>
      <td class="policy_table_title" colspan="8">船舶信息</td>
    </tr>
    <tr>
      <td class="policy_table_label">船龄</td>
      <td class="policy_table_field">{{ policy_table_info.ship_age }}</td>
      <td class="policy_table_label">船舶种类</td>
      <td class="policy_table_field">{{ policy_table_info.ship_type }}</td>
      <td class="policy_table_label">船籍港</td>
      <td class="policy_table_field">{{ policy_table_info.port_of_registry }}</td>
      <td class="policy_table_label">航行区域</td>
      <td class="policy_table_field">{{ policy_table_info.sailing_area }}</td>
    </tr>
    <tr>
      <td class="policy_table_label">总吨</td>
      <td class="policy_table_field">{{ policy_table_info.total_tons }}</td>
      <td class="policy_table_label">载重吨</td>
      <td class="policy_table_field">{{ policy_table_info.dwt }}</td>
      <td class="policy_table_label"></td>
      <td class="policy_table_field"></td>
      <td class="policy_table_label"></td>
      <td class="policy_table_field"></td>
    </tr>
  </table>
</template>

<script>
export default {
  name: "policy-info-table",
  props: {
    policy_table_info: Object
  },
  filters: {
    group_insurance_status: function(val){
      return val === 1 ? '是' : '否'
    },
    value2word: function (val){
      return val === 1 ? '是' : '否'
    }
  }
}
</script>

<style scoped>
  .policy_table {
    margin-left: 0%;
    margin-right: 0%;
    width: 100%;
  }
  .policy_table_label {
    width: 8%;
    font-weight: bold;
    font-size: 12px;
    line-height: 22px;
    padding-left: 5px;
    border-bottom: 1px;
  }
  .policy_table_field {
    border-bottom: 1px solid #fff;
    border-right: 2px solid #fff;
    width: 15%;
    padding-left: 5px;
    background-color: #F3F3F4;
  }
  .policy_table_title {
    text-align: center;
    font-weight: bold;
    background-color: #2f4050;
    color: #f9fafc;
    border: 1px solid #fff;
  }
</style>
